export default "__VITE_ASSET__DCEh7Rry__"